import React, { VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

export type LabelPillProps = {
  label: string;
  className?: string;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    fontWeight: 600,
    padding: '2px 4px',
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.33,
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
}));

const LabelPill: VFC<LabelPillProps> = ({ label, className }) => {
  const classes = useStyles();
  return <span className={clsx(classes.root, className)}>{label}</span>;
};

export default LabelPill;
